import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'
import moment from 'moment'

import {
    sendButtonClickSoundCommand,
} from 'react-wot-bootstrap/lib/helpers/web_to_client'

import Reserve from 'components/Reserve/Reserve.jsx'
import ReserveProgress from 'components/ReserveProgress/ReserveProgress'

import { ReserveActivationTimer } from '../../components'
import { RESERVE_MAIN_BONUS_DESCRIPTION } from './translations'

import { BONUS_TYPE_MESSAGES } from 'helpers/i18n.jsx'
import { canReceiveReserveBonus } from 'helpers/accounts'
import {
    getActivatedReserve,
    getCurrentLevel,
    getTargetType,
    getBonusValues,
} from 'helpers/reserves'
import { MEDIA_QUERIES, RESERVE_GROUPS, RESERVE_TYPES } from 'constants'

import styles from './ReserveButton.scss'

export class ReserveButton extends React.Component {
    static propTypes = {
        handleClick: PropTypes.func.isRequired,
        handleMouseEnter: PropTypes.func.isRequired,
        handleMouseLeave: PropTypes.func.isRequired,
        group: PropTypes.string.isRequired,
        reserveBonus: PropTypes.shape({
            type: PropTypes.string.isRequired,
            values: PropTypes.arrayOf(PropTypes.object).isRequired,
        }),
        reserveType: PropTypes.string.isRequired,
        reserves: PropTypes.object,
        hasActiveReserveInGroup: PropTypes.bool,
        tooltipId: PropTypes.string,

        account: PropTypes.object.isRequired,
        isEconomicsReserve: PropTypes.bool.isRequired,
        popoverOpened: PropTypes.bool,
        popoverReserveType: PropTypes.string,
        strongholdIsFrozen: PropTypes.bool.isRequired,
    }

    render() {
        const battleReserve = (RESERVE_GROUPS.DISPOSABLE === this.props.group)
        const activatedReserve = getActivatedReserve(this.props.reserves)
        const currentLevel = getCurrentLevel(activatedReserve, this.props.reserves)
        const reserveParameters = this.props.reserveBonus.values[currentLevel - 1].parameters
        const bonusValuesArray = getBonusValues(this.props.reserveBonus, currentLevel)

        const bonusValue = (() => {
            switch (this.props.reserveType) {
            case RESERVE_TYPES.INSPIRATION:
                return reserveParameters && reserveParameters.crewRolesFactor
            case RESERVE_TYPES.ARTILLERY_STRIKE:
                return reserveParameters && reserveParameters.maxDamage && reserveParameters.maxDamage.slice(-1)
            default:
                return bonusValuesArray.map(value => `+${value}`).join('\u2009/\u2009') // &thinsp;
            }
        })()
        const bonusText = (() => {
            switch (this.props.reserveType) {
            case RESERVE_TYPES.INSPIRATION:
            case RESERVE_TYPES.ARTILLERY_STRIKE:
                return RESERVE_MAIN_BONUS_DESCRIPTION[this.props.reserveType]
            default:
                return BONUS_TYPE_MESSAGES[this.props.reserveBonus.type]
            }
        })()

        const activationBlocked = this.props.hasActiveReserveInGroup && !activatedReserve
        const hasReservesOfMultipleLevels = Object.keys(this.props.reserves).length > 1
        const isCurrentReserveSelected = this.props.popoverOpened &&
                                         this.props.popoverReserveType === this.props.reserveType
        const currentLevelReserves = this.props.reserves[currentLevel]

        let popoverOffset
        if (battleReserve) {
            popoverOffset = '{ "bottom": 3 }'

            if (window.matchMedia(MEDIA_QUERIES.MEDIUM).matches) {
                popoverOffset = '{ "bottom": 12 }'
            }
        }

        const popoverType = getTargetType(this.props.group, bonusValuesArray)

        const isDisabled =
            (
                this.props.isEconomicsReserve &&
                (this.props.strongholdIsFrozen || !canReceiveReserveBonus(this.props.account))
            ) ||
            this.props.reserves[currentLevel].length === 0

        const className = classNames(styles.base, {
            [styles.base__typeEconomics]: this.props.isEconomicsReserve,
            [styles.base__typeBattle]: battleReserve,
            [styles.base__stateActivated]: activatedReserve,
            [styles.base__stateDisabled]: isDisabled,
            [styles.base__stateActivationBlocked]: activationBlocked,
            [styles.base__viewStack]: hasReservesOfMultipleLevels,
            [styles.base__selected]: isCurrentReserveSelected,
        })

        let timer
        let progress
        if (activatedReserve) {
            timer = (
                <div className={styles.timer}>
                    <ReserveActivationTimer endTime={moment(activatedReserve.effectEnds)} />
                </div>
            )
            progress = (
                <ReserveProgress
                    endTime={moment(activatedReserve.effectEnds)}
                    totalDuration={this.props.reserveBonus.values[activatedReserve.level - 1].duration}
                />
            )
        }

        // sendButtonClickSoundCommand accepts arguments, so we can't pass it directly to onMouseDown handler
        const playButtonClickSound = sendButtonClickSoundCommand.bind(null, undefined)

        return (
            <div key={this.props.reserveType} className={className}>
                {timer}
                <div
                    key={this.props.reserveType}
                    className={styles.button}
                    onClick={this.props.handleClick}
                    onMouseDown={playButtonClickSound}
                    onMouseEnter={this.props.handleMouseEnter}
                    onMouseLeave={this.props.handleMouseLeave}
                    data-popover-offset={popoverOffset}
                    data-popover-type={popoverType}
                    data-tip
                    data-for={this.props.tooltipId}
                >
                    <div className={styles.reserve}>
                        <Reserve
                            type={this.props.reserveType}
                            level={currentLevel}
                            modifier='toolbar'
                            reserves={currentLevelReserves}
                        />
                    </div>
                    {progress}
                </div>
                <div className={styles.bonus}>
                    <p className={styles.value}>{bonusValue}</p>
                    <p className={styles.text}>{bonusText}</p>
                </div>
            </div>
        )
    }
}

export const mapStateToProps = ({ account, clan, toolbar }, ownProps) => {
    const { popoverOpened, reserveType } = toolbar
    const strongholdIsFrozen = clan ? clan.industrial_resource < 0 : false

    const isEconomicsReserve = [RESERVE_GROUPS.DEVELOPMENT, RESERVE_GROUPS.ECONOMIC].includes(ownProps.group)

    return {
        account,
        popoverOpened,
        popoverReserveType: reserveType,
        strongholdIsFrozen,
        isEconomicsReserve,
    }
}

export default connect(mapStateToProps)(ReserveButton)



// WEBPACK FOOTER //
// ./containers/Stronghold/components/ReserveButton/ReserveButton.jsx